import React, { createContext, useState, useContext, useEffect } from 'react';
import AuthService from './authService';

// Auth Context erstellen
const AuthContext = createContext(null);

// Auth Provider Component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Beim Laden prüfen, ob ein User im localStorage gespeichert ist
  useEffect(() => {
    const checkUserLoggedIn = async () => {
      try {
        const isLoggedIn = await AuthService.isLoggedIn();
        if (isLoggedIn) {
          setUser(AuthService.getCurrentUser());
        }
      } catch (error) {
        console.error("Fehler beim Authentifizieren:", error);
      } finally {
        setLoading(false);
      }
    };

    checkUserLoggedIn();
  }, []);

  // Login-Funktion
  const login = async (username, password) => {
    try {
      const response = await AuthService.login(username, password);
      if (response.success) {
        setUser(response.user);
        return { success: true };
      } else {
        return { success: false, message: response.message || 'Login fehlgeschlagen' };
      }
    } catch (error) {
      return { 
        success: false, 
        message: error.message || 'Ein Fehler ist beim Login aufgetreten' 
      };
    }
  };

  // Logout-Funktion
  const logout = () => {
    AuthService.logout();
    setUser(null);
  };

  // Context-Werte bereitstellen
  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook für einfachen Zugriff auf den Auth-Kontext
export const useAuth = () => useContext(AuthContext);